export default __webpack_public_path__ + "static/media/68_mobile.5c24b2da.jpg";